import { IBasicFile } from '@sdk/contracts';
import { Button, Popconfirm, Spin } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

import { DocName, IconWrapper, Wrapper } from './DocumentDisplay.styles';

import { downloadFile, getFileDownloadInfo, getFileIcon } from '@/utils';

interface Props {
  file: IBasicFile;
  isEditable: boolean;
  handleDelete: (id: string) => void;
  type?: string;
}

export const DocumentDisplay = ({ file, isEditable, handleDelete, type }: Props) => {
  const { t } = useTranslation('CommonEventTranslations');
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;

    setIsDownloading(true);
    try {
      const { urlToDownload, filename } = getFileDownloadInfo(file);
      await downloadFile(urlToDownload, filename);
    } finally {
      setIsDownloading(false);
    }
  };

  const iconName = getFileIcon(type ? type : file.name);
  return (
    <Wrapper onClick={handleDownload} $isDownloading={isDownloading}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <IconWrapper iconName={iconName}>
          {isDownloading ? <Spin size="small" /> : <Icon size={15.8} i={iconName} color="white" />}
        </IconWrapper>
        <DocName>{isDownloading ? t('DOWNLOADING') : file.name}</DocName>
      </div>
      {isEditable && (
        <div onClick={e => e.stopPropagation()}>
          <Popconfirm
            placement="left"
            onConfirm={() => handleDelete(file._id)}
            title={t('ARE_YOU_SURE_DELETE_THIS_ATTACHMENT')}>
            <Button
              type="link"
              icon={<Icon color={'black7'} i="TrashCan" />}
              size="large"
              onClick={e => e.stopPropagation()}
            />
          </Popconfirm>
        </div>
      )}
    </Wrapper>
  );
};
